import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../../components/ui";

export default function TagsSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Tags</CardTitle>
        <CardDescription>Manage reusable CRM tags.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-sm text-muted-foreground">
          Tags settings module in progress.
        </div>
      </CardContent>
    </Card>
  );
}